import { render } from "./Referral.vue?vue&type=template&id=6255b812"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"
script.render = render

export default script